import axios from 'axios';
import config from '@/config';
var instance = axios.create({
	timeout: 3000,
	baseURL: config.BASE_URL
});
//请求发送之前
instance.interceptors.request.use(config => {
	return config
}, error => {
	return Promise.reject(error)
});
//响应之后
instance.interceptors.response.use(({
	data: {
		message,
		data,
		code
	},
	config: {
		method
	}
}) => {
	if (code != 200) {
		return alert('响应失败:'+data.message)
	} else {
		return data
	}
}, ({
	response: {
		status,
		data
	}
}) => {
	alert('响应失败')
	return Promise.reject()
});
// 通用方法
export default {
	// 通用跳转方法的封装
	$get(url, params) {
		return instance.get(url, {
			params
		})
	},
	$post(url, data) {
		return instance.post(url, data)
	},
	$put(url, data) {
		return instance.put(url, data)
	},
	$del(url, data) {
		return instance.delete(url, data)
	}
}	